import { useEffect } from "react";
import { Center, Loader, Stack, Text } from "@mantine/core";

import { signOut } from "@/auth/provider";

/**
 * Imperative logout. Clears in-memory state and redirects to IAM's
 * end-session endpoint. The browser never returns to this component —
 * the spinner is purely cosmetic for the brief gap before navigation.
 */
export function LogoutPage(): JSX.Element {
  useEffect(() => {
    void signOut();
  }, []);

  return (
    <Center h="100vh">
      <Stack align="center" gap="md">
        <Loader />
        <Text c="dimmed">Signing out...</Text>
      </Stack>
    </Center>
  );
}
